import React, { useEffect } from 'react'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Facebook, GitHub, Instagram, Linkedin, Menu, Slack, Tv, Twitter, X } from 'react-feather'
import aos from 'aos'
import logo from "../assets/images/logo/khuram.png"



const Footer = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])
    return (
        <>
            {/* <!-- Rn footer area Start --> */}
            <div id="footer" className="rn-footer-area footer-style-2 rn-section-gapTop section-separator">
                <div className="container pb--80 pb_sm--40 plr_sm--20">
                    <div className="row">
                        <div className="col-xl-3 col-12 col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="logo-thumbnail">
                                <a href="#"><img src={logo} alt="logo-image" /></a>
                            </div>
                            <div className="social-icone-wrapper">
                                <ul className="social-share d-flex liststyle">
                                    <li className="facebook"><a href="https://app.slack.com/client/T02J391F0UE/D033DA58GP6/user_profile/U02JNJWTHC1" target="_blank"><Slack /></a>
                                    </li>
                                    <li className="linkedln"><a href="skype:live:khuramhaseeb1150" target="_blank"><i style={{ color: 'black', marginTop: '15px' }} className="fa-brands fa-skype fa-2x"></i></a>
                                    </li>
                                    <li className="instagram"><a href="https://github.com/Khuram-Haseeb1150" target="_blank"><GitHub />
                                    </a>
                                    </li>
                                    <li className="instagram"><a href="https://www.linkedin.com/in/khuram-haseeb/" target="_blank"><Linkedin />
                                            </a>
                                            </li>
                                            <li className="instagram"><a href="https://web.facebook.com/ranakhuram.prince.7" target="_blank"><Facebook />
                                            </a>
                                            </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sl-3 col-12 mt_sm--20 col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="menu-wrapper">
                                <div className="menu-title">
                                    <h6>product</h6>
                                </div>
                                <ul className="menu-footer">
                                    <li><a href="#">Database</a></li>
                                    <li><a href="#">Authentication</a></li>
                                    <li><a href="#">Storage</a></li>
                                    <li><a href="#">Support</a></li>
                                    <li><a href="#">Pricing</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sl-3 col-12 mt_sm--20 col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="menu-wrapper">
                                <div className="menu-title">
                                    <h6>Resources</h6>
                                </div>
                                <ul className="menu-footer">
                                    <li><a href="#">Authentication</a></li>
                                    <li><a href="#">System Status</a></li>
                                    <li><a href="#">Terms of service</a></li>
                                    <li><a href="#">Pricing</a></li>
                                    <li><a href="#">over right</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-sl-3 col-12 mt_sm--20 col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="menu-wrapper">
                                <div className="menu-title">
                                    <h6>Developers</h6>
                                </div>
                                <ul className="menu-footer">
                                    <li><a href="#">Documentation</a></li>
                                    <li><a href="#">Authentication</a></li>
                                    <li><a href="#">API Reference</a></li>
                                    <li><a href="#">Support</a></li>
                                    <li><a href="#">Open Source</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright text-center ptb--40 section-separator">
                    <p className="description">© 2022. All rights reserved </p>
                </div>






            </div>
        </>
    )
}

export default Footer